import { render, staticRenderFns } from "./CadastroOrcamentoItem.vue?vue&type=template&id=d80546d2&"
import script from "./CadastroOrcamentoItem.vue?vue&type=script&lang=ts&"
export * from "./CadastroOrcamentoItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VCol,VDialog,VForm,VIcon,VRow,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/Users/renan/Fontes/OngFacil/Edital-Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d80546d2')) {
      api.createRecord('d80546d2', component.options)
    } else {
      api.reload('d80546d2', component.options)
    }
    module.hot.accept("./CadastroOrcamentoItem.vue?vue&type=template&id=d80546d2&", function () {
      api.rerender('d80546d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ong/projeto/CadastroOrcamentoItem.vue"
export default component.exports